/**
 * US-style state for display: 2-letter abbreviations are shown uppercase (MO not mo).
 * Longer values are left as stored (full state names).
 * @param {string|undefined|null} state
 * @returns {string|undefined}
 */
function formatStateForDisplay(state) {
  if (state == null || typeof state !== "string") return state;
  const t = state.trim();
  if (!t) return t;
  if (t.length <= 2 && /^[a-zA-Z]+$/.test(t)) return t.toUpperCase();
  return t;
}

/**
 * Get display address from a unit (handles both legacy address string and discrete fields).
 * Use this whenever displaying unit address in the UI to ensure compatibility with
 * both old (address-only) and new (address_street, address_city, address_state, address_zip) data.
 * @param {Object} unit - Unit object from Firestore
 * @returns {string} Formatted address string
 */
export function getUnitDisplayAddress(unit) {
  if (!unit) return "";
  if (
    unit.address_street ||
    unit.address_city ||
    unit.address_state ||
    unit.address_zip
  ) {
    return [
      unit.address_street,
      unit.address_city,
      formatStateForDisplay(unit.address_state),
      unit.address_zip,
    ]
      .filter(Boolean)
      .join(", ");
  }
  if (typeof unit.address === "string" && unit.address.trim())
    return unit.address.trim();
  if (unit.address && typeof unit.address === "object") {
    const addr = unit.address;
    return [
      addr.street || addr.address,
      addr.city,
      formatStateForDisplay(addr.state),
      addr.zipCode || addr.zip,
    ]
      .filter(Boolean)
      .join(", ")
      .replace(/,\s*,/g, ",")
      .replace(/^,\s*|,\s*$/g, "")
      .trim();
  }
  return unit.address || "";
}
